import React from 'react'
import { HomePageWrapper } from './style'
import tryThiswayLogo from '../../assets/trythisway.png'
import { PrimaryButton } from '../../components/theme-components'
import { CalendarOutlined, UnlockOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router'


const Home = () => {
    const navigate = useNavigate()

    const handleRequestAccess = () => {
        navigate(`signup/${process.env.REACT_APP_LANDING_PAGE_CAMPAIGN_ID}`)
    }

    return (
        <HomePageWrapper>
            <div>
                <img src={tryThiswayLogo} alt='' />
                <p>Over 169 Million Candidates at Your Fingertips</p>
            </div>
            <div>
                <iframe width="1280" height="720" src="https://www.youtube.com/embed/Yn7n6NvNgl0" title="Try ThisWay Demo v5" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
            <div>
                <PrimaryButton className='primary-button'
                    onClick={()=>handleRequestAccess()}
                >
                    <div className='primary-button-container'>
                        <div className='icon'><UnlockOutlined style={{ fontSize: '15px' }} /></div>
                        <div>Request Access</div>
                        <div className='arrow'>&#8594;</div>
                    </div>
                </PrimaryButton>
                <div><span style={{ color: ' #a2a2a2' }}>OR</span></div>
                <div className='text-link'
                    onClick={()=>window.open('https://meetings.hubspot.com/thisway-global/demo-request', '_blank')}
                >
                    <div><CalendarOutlined style={{ fontSize: '15px' }} /></div>
                    <div>Schedule a Meeting</div>
                </div>
            </div>
        </HomePageWrapper>
    )
}

export default Home